/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Email_PlaceholderInputs */

const en_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const de_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const fr_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const es_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`you@example.com`)
};

const it_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu@esempio.com`)
};

const nl_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jij@voorbeeld.nl`)
};

const pl_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ty@przyklad.pl`)
};

const fi_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sinä@esimerkki.com`)
};

const da_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dig@eksempel.com`)
};

const sv_auth_email_placeholder = /** @type {(inputs: Auth_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`du@exempel.com`)
};

/**
* | output |
* | --- |
* | "you@example.com" |
*
* @param {Auth_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_email_placeholder = /** @type {((inputs?: Auth_Email_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Email_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_email_placeholder(inputs)
	if (locale === "fr") return fr_auth_email_placeholder(inputs)
	if (locale === "es") return es_auth_email_placeholder(inputs)
	if (locale === "it") return it_auth_email_placeholder(inputs)
	if (locale === "nl") return nl_auth_email_placeholder(inputs)
	if (locale === "pl") return pl_auth_email_placeholder(inputs)
	if (locale === "fi") return fi_auth_email_placeholder(inputs)
	if (locale === "da") return da_auth_email_placeholder(inputs)
	if (locale === "sv") return sv_auth_email_placeholder(inputs)
	return en_auth_email_placeholder(inputs)
});